import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ReportResponseService } from '../../../services/report_response.service';
import { PeriodService } from '../../../../periods/period.service';
import { ReportStatesService } from '../../../../shared/services/report_states.service';
import { LicenseService } from '../../../../user/services/license.service';
import Swal from 'sweetalert2';
import { ReportPaymentService } from '../../../services/report_payment.service';

@Component({
  selector: 'app-generate-layout-payments',
  templateUrl: './generate-layout-payments.component.html',
  styleUrl: './generate-layout-payments.component.scss'
})
export class GenerateLayoutPaymentsComponent {
  selectedFile: File | null = null;
  selectedFiles: File[] = [];
  paymentComment: string = '';

  reports: any[] = []
  periods: any[] = []
  paymentCritreria: any = "";
  paymentCriteriaOptions: any[] = ["Pagar Aprobados", "Pagar Rechazados", "Pagar Ambos"];
  paymentCriteriaTime: any[] = ["Dentro de Plazo", "Fuera de plazo", "Pagar Ambos"]
  reportstates: any[] = []
  stateId: string = '';
  selectedPeriod: any = '';
  paymentTitle: string = '';


  constructor(
    private router: Router,
    private reportResponseService: ReportResponseService,
    private periodService: PeriodService,
    private reportStatesService: ReportStatesService,
    private licenseService: LicenseService,
    private reportPaymentService: ReportPaymentService
  ) { }

  ngOnInit(): void {
    this.loadPeriods();
    this.loadReportStates();
  }

  loadPeriods(): void {
    this.periodService.get().subscribe({
      next: (response) => {
        this.periods = response;
      },
      error: (error) => {
        console.error("Error al cargar los periodos:", error);
      }
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles = Array.from(input.files);
    }
  }


  savePayment(): void {
    if (!this.selectedFiles || this.selectedFiles.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Por favor, seleccione al menos un archivo.',
      });
      return;
    }

    const formData = new FormData();
    this.selectedFiles.forEach(file => {
      formData.append('files', file);
    });
    formData.append('comment', this.paymentComment);
    formData.append('periodId', this.selectedPeriod);
    formData.append('stateId', this.stateId);
    formData.append('title', this.paymentTitle);

    //icono de carga
    Swal.fire({
      title: 'Guardando pago...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.reportPaymentService.save(formData).subscribe({
      next: (response) => {
        if (response) {
          Swal.close();
          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: 'Pago guardado correctamente.',
          });
          this.selectedFile = null; // Resetea el archivo seleccionado
          this.paymentComment = ''; // Resetea el comentario
          this.selectedFiles = []; // Resetea los archivos seleccionados
          this.paymentTitle = ''; // Resetea el título del pago
          this.selectedPeriod = ''; // Resetea el periodo seleccionado
          this.stateId = ''; // Resetea el estado seleccionado
          this.loadReportResponses(this.selectedPeriod, this.stateId); // Recarga los reporte
        }

      },
      error: (error) => {
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al guardar el pago. Por favor, inténtelo de nuevo.',
        });
        console.error("Error al guardar el pago:", error);
      }
    });

    // Cierra el modal después de subir (puedes usar bootstrap programáticamente si es necesario)
  }

  onSearch(): void {
    if (!this.selectedPeriod) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Por favor, seleccione un periodo.',
      });
      return;
    }
    if (!this.stateId) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Por favor, seleccione un estado.',
      });
      return;
    }

    this.loadReportResponses(this.selectedPeriod, this.stateId);
  }

  onChangePeriod(event: any): void {
    this.selectedPeriod = event.target.value;
    this.loadReportResponses(this.selectedPeriod, this.stateId);
  }

  onChangeState(event: any): void {
    this.stateId = event.target.value;
    this.loadReportResponses(this.selectedPeriod, this.stateId);
  }


  onChangeCriteria(event: any): void {
    this.paymentCritreria = event.target.value;
    console.log("Selected criteria:", this.paymentCritreria);
  }

  loadReportResponses(period: string, stateId: string): void {
    //icono de carga
    Swal.fire({
      title: 'Cargando...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.reportResponseService.getViewNoPagination(period, '', stateId).subscribe({
      next: (response) => {
        Swal.close(); // Cierra el modal de carga
        this.reports = response;
      },
      error: (error) => {
        Swal.close(); // Cierra el modal de carga
        console.error("Error al cargar los reportes:", error);
      }
    });
  }

  loadReportStates(): void {
    this.reportStatesService.get().subscribe({
      next: (response) => {
        this.reportstates = response;
      },
      error: (error) => {
        console.error("Error al cargar los estados de reportes:", error);
      }
    });
  }

  downloadPDF(): void {
    //icono de carga
    Swal.fire({
      title: 'Cargando PDF...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.reportResponseService.downloadPDF(this.selectedPeriod).subscribe({
      next: (response: Blob) => {
        Swal.close(); // Cierra el modal de carga
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'reporte-pagos.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        Swal.close(); // Cierra el modal de carga
        console.error("Error al descargar el PDF:", error);
      }
    });
  }

  downnloadExcel(): void {
    this.reportResponseService.downloadExcel(this.selectedPeriod, this.stateId).subscribe({
      next: (response: Blob) => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'reporte-pagos.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error("Error al descargar el Excel:", error);
      }
    });
  }

  /*   generatePDF(): void {
      const element = this.pdfTable.nativeElement;
      html2canvas(element).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
    
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    
        pdf.addImage(imgData, 'PNG', 0, 10, pdfWidth, pdfHeight);
        pdf.save('reporte-pagos.pdf');
      });
    } */
}
